import { useStrict, autorun, toJS } from "mobx"
import authStore from "../auth/auth-store"
import invoiceStore from "../account/invoices/invoice-store"
import billingStore from "../account/billing/billing-store"
import channelStore from "../channel/channel-store"
import teamStore from "../dashboard/team-store"

useStrict(true)
if (process.env.NODE_ENV === "development") {
  autorun(() => console.log("authStore", toJS(authStore)))
  autorun(() => console.log("teamStore", toJS(teamStore)))
  autorun(() => console.log("billingStore", toJS(billingStore)))
  autorun(() => console.log("channelStore", toJS(channelStore)))
  autorun(() => console.log("invoiceStore", toJS(invoiceStore)))
  window.authStore = authStore
  window.teamStore = teamStore
  window.billingStore = billingStore
  window.channelStore = channelStore
  window.invoiceStore = invoiceStore
}

export { authStore, teamStore, billingStore, channelStore, invoiceStore }



// WEBPACK FOOTER //
// ./src/app/stores.js